import React from "react"
import { string, shape, node, bool, func, oneOf } from "prop-types"
import classNames from "classnames"
import { Link as RouterLink } from "react-router-dom"

import ThemeConsumer from "../ThemeConsumer"

const Link = ({
  children,
  theme,
  callToAction,
  callToActionLink,
  to,
  weight,
  toLinkBtn,
  toLinkBtnBorder,
  onClick,
  isExternal,
  target,
  id,
  className
}) => {
  const classes = classNames(
    theme.link,
    { [theme["call-to-action"]]: callToAction },
    { [theme["call-to-action-bg"]]: callToActionLink },
    { [theme["to-link-btn"]]: toLinkBtn },
    { [theme["to-link-btn-border"]]: toLinkBtnBorder },
    { [theme[weight]]: !!weight },
    className
  )

  return isExternal ? (
    <a
      id={id}
      className={classes}
      href={to}
      target={target}
      onClick={onClick}
      rel="noopener noreferrer"
    >
      {children}
    </a>
  ) : (
    <RouterLink id={id} className={classes} to={to} onClick={onClick}>
      {children}
    </RouterLink>
  )
}

Link.propTypes = {
  children: node,
  callToAction: bool,
  callToActionLink: bool,
  toLinkBtnBorder: bool,
  to: string.isRequired,
  isExternal: bool,
  target: string,
  toLinkBtn: bool,
  theme: shape({
    "call-to-action": string,
    fit: string
  }),
  weight: oneOf(["fit"]),
  onClick: func,
  id: string,
  className: string
}

Link.defaultProps = {
  children: null,
  theme: {},
  target: "",
  isExternal: false,
  toLinkBtnBorder: false,
  callToAction: false,
  callToActionLink: false,
  weight: null,
  toLinkBtn: false,
  onClick: null,
  className: ""
}

export default ThemeConsumer("UILink")(Link)



// WEBPACK FOOTER //
// ./src/shared/components/Link/index.js